import { useMemo } from 'react';
import { Column, TextButton, Typography } from 'seagull';
import { PlusCircleLine } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { legalTermsModel } from "../../../../models";
import { LegalTermsDropdown } from "../../../LegalTermsDropdown/LegalTermsDropdown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetLegalTermsTID = prefixTestId => getTestIds(prefixTestId);
export const LegalTerms = _ref => {
  let {
    agreementLegalTerms,
    onAgreementLegalTermsChange,
    isReadOnly,
    testid
  } = _ref;
  const mappedAgreementLegalTerms = useMemo(() => {
    if (agreementLegalTerms.length === 0) {
      return [];
    }
    return legalTermsModel.fromRelationshipLegalTerms(agreementLegalTerms.filter(legalTerm => !!legalTerm));
  }, [agreementLegalTerms]);
  const {
    LegalTermsTID
  } = useMemo(() => GetLegalTermsTID(testid), [testid]);
  const onLegalTermsChange = (legalTerms, index) => {
    const updatedAgreementLegalTerms = [...agreementLegalTerms];
    updatedAgreementLegalTerms[index] = legalTerms ? legalTermsModel.toDraftLegalTermsDocuments(legalTerms) : null;
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  const onAddAdditionalTermsOfService = () => {
    onAgreementLegalTermsChange([...agreementLegalTerms, null]);
  };
  const isMaxLegalTermsReached = (agreementLegalTerms === null || agreementLegalTerms === void 0 ? void 0 : agreementLegalTerms.length) >= 4;
  const onRemoveLegalTerm = index => {
    const updatedAgreementLegalTerms = agreementLegalTerms.filter((_, i) => i !== index);
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  return /*#__PURE__*/_jsxs(Column, {
    gap: 24,
    children: [agreementLegalTerms.length > 1 && /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      "data-testid": LegalTermsTID.Title(),
      children: "Terms of Service"
    }), agreementLegalTerms.map((legalTerm, index) => {
      var _legalTerm$legalTerms;
      return /*#__PURE__*/_jsx(LegalTermsDropdown, {
        entityLegalTerms: mappedAgreementLegalTerms,
        onSelectLegalTerm: updatedLegalTerm => {
          onLegalTermsChange(updatedLegalTerm, index);
        },
        selectedLegalTermId: legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.legalTermsId,
        disabled: isReadOnly,
        testid: LegalTermsTID.LegalTermDropdown(index),
        onRemoveLegalTerm: index > 0 ? () => onRemoveLegalTerm(index) : undefined
      }, (_legalTerm$legalTerms = legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.legalTermsId) !== null && _legalTerm$legalTerms !== void 0 ? _legalTerm$legalTerms : index);
    }), !isMaxLegalTermsReached && /*#__PURE__*/_jsx(TextButton, {
      "data-testid": LegalTermsTID.AddAdditionalTermsOfService(),
      onClick: onAddAdditionalTermsOfService,
      underline: "none",
      prefixIcon: /*#__PURE__*/_jsx(PlusCircleLine, {}),
      children: "Add additional Terms of Service"
    })]
  });
};